/**
 * @fileoverview Back-compat shims for the old bottom tab bar.
 *
 * The instructor portal now uses the persistent left sidebar
 * (`components/studio/StudioLayout` + `StudioSidebar`). Pages historically
 * rendered `<Sidebar />` and `<MobileNav />` inline; those now render nothing
 * so the single shell-provided sidebar is the only navigation. These exports
 * remain so any un-migrated import keeps working.
 */

/** No-op: navigation is provided by StudioLayout. */
export const BottomNav = () => null;

/** No-op back-compat alias (was the bottom tab bar). */
export const Sidebar = () => null;

/** No-op back-compat alias. */
export const MobileNav = () => null;

export default BottomNav;
